module.exports = "<p class=\"alert alert-info\">Info message</p>\n\n#### Level 4 title\n\n##### Level 5 title\n\n###### Level 6 title";